import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SingleOrderComponent from "./SingleOrderComponent.jsx"
import { allOrdersAction } from '../../../redux/actions/orderActions.js'

const OrdersList = ({ setShowOrders, orderID, setOrderID, setOrderData }) => {


  const dispatch = useDispatch()

  const [perPage, setPerPage] = useState(20)
  const [queryOrderID, setQueryOrderID] = useState(null)


  const { loading, totalOrders, orders } = useSelector((state) => state.orders)



  useEffect(() => {


    const query = {}
    if (perPage) query.perPage = perPage
    if (queryOrderID) query.order_id = queryOrderID
    // dispatch API
    dispatch(allOrdersAction(query))

  }, [dispatch, perPage, queryOrderID])
    return (
        <Fragment>
            <section className="fixed inset-0 z-[999999999] bg-black/50 backdrop-blur-sm flex justify-center items-start pt-[5vmax]">
                <div className="w-[90%] md:w-[60%] lg:w-[35%] bg-white rounded-2xl p-[2vmax] shadow-xl animate-[fadeIn_.2s_ease] border border-gray-100">
                    
                    {/* Header */}
                    <div className="flex justify-between items-center mb-[1.5vmax]">
                        <div>
                            <h2 className='text-[1.4vmax] font-bold text-gray-800'>Orders List</h2>
                            <p className='text-[0.85vmax] text-gray-500'>Browse and select Order to Tag in a Message</p>
                        </div>
                        <button
                            className="w-[2.5vmax] h-[2.5vmax] bg-gray-50 text-gray-500 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                            onClick={() => setShowOrders(false)}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    </div>

                    {/* SEARCH INPUT */}
                    <div className="w-full flex items-center bg-gray-50 border border-gray-100 p-[0.7vmax_1vmax] rounded-lg focus-within:border-indigo-300 transition-colors mb-[1.5vmax]">
                        <i className="fa-solid fa-magnifying-glass text-gray-400 mr-[0.5vmax]"></i>
                        <input
                            type="text"
                            placeholder='Search with Order ID'
                            className='w-full bg-transparent outline-none text-[0.9vmax] font-medium text-gray-700 placeholder-gray-400'
                            value={queryOrderID}
                            onChange={(e) => setQueryOrderID(e.target.value)}
                        />
                    </div>

                    <h3 className='text-[0.8vmax] font-bold text-gray-400 uppercase tracking-wider mb-[0.5vmax]'>
                        {totalOrders || 0} Orders available
                    </h3>

                    {/* ORDERS LIST */}
                    <div className="max-h-[40vh] overflow-y-auto my-scroll pr-[0.5vmax] mb-[1.5vmax]">
                        {orders?.length > 0 ? (
                            orders.map(order => (
                                <SingleOrderComponent
                                    key={order.id}
                                    order={order}
                                    orderID={orderID}
                                    setOrderID={setOrderID}
                                    setOrderData={setOrderData}
                                />
                            ))
                        ) : (
                            !loading && <h2 className='text-center text-gray-500 my-[1vmax] text-[0.9vmax]'>No Orders Found</h2>
                        )}

                        {!loading && totalOrders > perPage && (
                            <div className="flex justify-center mt-[1vmax]">
                                <button
                                    className="text-[0.85vmax] font-bold text-indigo-600 hover:text-indigo-700"
                                    onClick={() => setPerPage(prev => prev + 20)}
                                >
                                    Load More
                                </button>
                            </div>
                        )}

                        {loading && (
                            <div className="w-[2vmax] h-[2vmax] border-4 border-gray-200 border-t-indigo-600 rounded-full animate-spin mx-auto my-[2vmax]" />
                        )}
                    </div>

                    {/* Action Button */}
                    <button
                        className={`text-white rounded-lg p-[0.8vmax_1vmax] w-full font-bold text-[0.9vmax] transition-colors ${orderID ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-gray-300 cursor-not-allowed'}`}
                        onClick={() => setShowOrders(false)}
                        disabled={!orderID}
                    >
                        Tag this Order
                    </button>
                </div>
            </section>
        </Fragment>
  )
}

export default OrdersList
